import { registerPlugin } from '@capacitor/core';

import type { NuanceSpeechkitPlugin } from './definitions';

const NuanceSpeechkit = registerPlugin<NuanceSpeechkitPlugin>(
  'NuanceSpeechkit',
  {
    web: () => import('./web').then(m => new m.NuanceSpeechkitWeb()),
  },
);

export * from './definitions';
export { NuanceSpeechkit };
